var _JoinCommand_instances, _JoinCommand_getUri, _JoinCommand_getBody;
import { __classPrivateFieldGet } from "tslib";
import axios from 'axios';
export class JoinCommand {
    constructor() {
        _JoinCommand_instances.add(this);
    }
    async execute(id, pw, nick) {
        const url = __classPrivateFieldGet(this, _JoinCommand_instances, "m", _JoinCommand_getUri).call(this);
        try {
            const res = await axios.post(url, __classPrivateFieldGet(this, _JoinCommand_instances, "m", _JoinCommand_getBody).call(this, id, pw, nick));
            return true;
        }
        catch (_a) {
            return false;
        }
    }
}
_JoinCommand_instances = new WeakSet(), _JoinCommand_getUri = function _JoinCommand_getUri() {
    return 'https://mycast.xyz:3001/join';
}, _JoinCommand_getBody = function _JoinCommand_getBody(id, pw, nick) {
    return `vgid=${id}&vgpw=${pw}&vgnick=${nick}`;
};
